import {
  Box,
  Typography,
  MenuItem,
  Select,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { BASE_URL } from '../../../../components/BaseUrl';
import { toast } from 'react-hot-toast';
import { decryptToken } from '../../../../Utlis/Encryption';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg";
import CustomText, { textStyles } from "../../../../components/CustomText"

// 🔐 Decrypt token from localStorage
const rawEncryptedToken = localStorage.getItem('token');
const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

const MatricGraph = ({companyId}) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  // ✅ Generate all years from 2000 to current year
  const allYears = Array.from({ length: currentYear - 2000 + 1 }, (_, i) =>
    String(2000 + i)
  );

  const [selectedYear, setSelectedYear] = useState(String(currentYear));
  const [chartDataByYear, setChartDataByYear] = useState({});

  const monthMap = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
    'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  // 📊 Fetch chart data for selected year
  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/company-admins/${companyId}/workers-metrics?year=${selectedYear}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        const result = await response.json();
        console.log("matric result",result)

        if (!result?.error && result?.data?.metrics) {
          const metrics = result.data.metrics;

          const formatted = metrics.map((item) => ({
            month: monthMap[item.month - 1],
            users: item.count,
          }));

          setChartDataByYear((prev) => ({
            ...prev,
            [selectedYear]: formatted,
          }));
        } else {
          toast.error('Failed to fetch chart data.');
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
        toast.error('Unable to load worker metrics.');
      }
    };

    if (token && selectedYear) {
      fetchChartData();
    }
  }, [selectedYear]);

  return (



    <Box
  sx={{
    backgroundColor: '#fff',
    borderRadius: 2,
    border: '1px solid #E4E6EF',
    p: 3,
    mt: 2,
  }}
>
  <Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 5 }}>
      <Typography
        sx={{
          fontSize: 15,
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 700,
          color: '#212121',
        }}
      >
        {t('activeDetails.usersMetrics')}
      </Typography>

      <Select
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
        size="small"
        sx={{ borderRadius: '6px', fontSize: 14, height: 30 }}
        MenuProps={{
          PaperProps: {
            sx: {
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            },
          },
        }}
      >
        {allYears.map((year) => (
          <MenuItem key={year} value={year} sx={{ fontSize: '14px' }}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </Box>

    {/* ✅ Conditionally render chart or empty screen */}
    {(chartDataByYear[selectedYear]?.length === 0 ||
      chartDataByYear[selectedYear]?.every(item => item.users === 0)) ? (
       <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptyscreen} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('empty.no_user')}
  </CustomText>

        </Box>
    ) : (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartDataByYear[selectedYear]}>
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
            strokeWidth={1}
            stroke="#E4E6EF"
          />
          <XAxis dataKey="month" stroke="#A3A3A3" fontSize={12} />
          <YAxis
            type="number"
            domain={[0, 6000]}
            ticks={[
              0, 100, 200, 300, 400, 500, 600,
              1000, 2000, 3000, 4000, 5000, 6000,
            ]}
            stroke="#A3A3A3"
            fontSize={12}
            tickLine={false}
            axisLine={false}
            tickFormatter={(value) => {
              if (value === 1000) return '1K';
              if (value === 2000) return '2K';
              if (value === 3000) return '3K';
              if (value === 4000) return '4K';
              if (value === 5000) return '5K';
              if (value === 6000) return '6K';
              return value;
            }}
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            contentStyle={{ border: 'none', boxShadow: 'none' }}
          />
          <Bar
            dataKey="users"
            fill="#579DFF"
            barSize={10}
            radius={[4, 4, 0, 0]}
            activeBar={false}
          />
        </BarChart>
      </ResponsiveContainer>
    )}
  </Box>
</Box>

  );
};

export default MatricGraph;








